// src/components/AuthModal/WalletLogin.jsx
// Botón simple "Entrar con tu wallet" (camino del usuario que VUELVE). Usa el hook
// useWalletLogin (puente SIWE compartido). Para el alta de un usuario nuevo, el
// flujo guiado está en WalletOnboarding.
//
// Este componente SOLO se monta cuando hay REACT_APP_PRIVY_APP_ID configurado
// (lo decide AuthModal), así los hooks de Privy nunca corren sin su provider.
import React from 'react';
import { FiArrowRight, FiShield, FiCheck } from 'react-icons/fi';
import { FaWallet } from 'react-icons/fa';
import { useWalletLogin } from '../../lib/useWalletLogin';

export default function WalletLogin({ onSuccess }) {
  const { start, status, error, ready, busy } = useWalletLogin(onSuccess);

  const label = status === 'signing'    ? 'Firmá en tu wallet…'
              : status === 'verifying'  ? 'Verificando…'
              : status === 'connecting' ? 'Conectando…'
              : 'Entrar con tu wallet';

  return (
    <div className="am-wallet">
      <button
        type="button"
        className="am-wallet-btn"
        onClick={start}
        disabled={!ready || busy}
      >
        <FaWallet className="am-wallet-ic" />
        {busy ? <span className="am-spin" /> : <>{label} <FiArrowRight /></>}
      </button>

      {error && <div className="am-error">{error}</div>}

      {/* Pantalla de firma honesta (capa educativa "for dummies") */}
      <div className="am-wallet-edu">
        <FiShield className="am-wallet-edu-ic" />
        <span>
          <strong>Firmar para entrar ≠ darnos permiso de mover tu plata.</strong>{' '}
          Solo prueba que la wallet es tuya. Vos tenés la única llave —
          ni Bitplify ni nadie puede sacar tus fondos.
        </span>
      </div>
      <ul className="am-wallet-points">
        <li><FiCheck /> Tu plata vive en tu wallet, no en Bitplify (autocustodia).</li>
        <li><FiCheck /> Sin contraseñas ni semillas: entrás con tu llave.</li>
      </ul>
    </div>
  );
}
